import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Header from "../Home/Component/Header";
import Footer from "../../../../../Assessment/Home/Component/Footer";
import moment from 'moment';

import { assessmentActions } from "../../../../../../_actions";

class BackSummary extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.state = {

    }
  }

  componentDidMount() {

    console.log("window.location--->", window.location.hash)
    let pathname = window.location.hash;
    let sCode = pathname.replace('#/assessment/expert-booked/', '')

    console.log("pathname///////////////////--------------------->", pathname);
    console.log("sCode///////////////////--------------------->", sCode);


    let data = {
      sCode: sCode
    };
    console.log("data--->", data)


    // add REdux flow 
    // this.props.dispatch(assessmentActions.expertSuccessOrder(data));

    this.props.dispatch(assessmentActions.expertBookingSuccess(data));
  }

  render() {

    let { assessment } = this.props;
    let { getExpertOrderBookListData, getExpertOrderBookIdData, expertBookingSuccessData } = assessment;

    console.log('getExpertOrderBookIdDatagetExpertOrderBookIdDatagetExpertOrderBookIdData', getExpertOrderBookIdData);


    function getExpertDetails(ele, type, a, b) {
      let value = "";
      if (type === 1) {
        if (ele && ele[a]) {
          value = ele[a]
        }
      } else if (type === 2) {
        if (ele && ele[a] && ele[a][b]) {
          value = ele[a][b]
        }
      }
      return value
    }

    return (
      <>


        <div className="flex items-center justify-center mx-auto mt-10 ">
          <div className="w-full px-4 mx-auto 2xl:w-9/12 xl:w-10/12 xl:px-0">
            <div className="flex flex-col-reverse md:flex-row justify-between items-center bg-[#E8F5E9] md:p-10 p-6 w-full">
              <div className="w-full space-y-6">
                <div>
                  <h1 className="md:text-4xl text-3xl font-medium text-[#3D405B] md:text-left text-center">Expert Booking Successful</h1>
                  <p className="m-1 mt-2">Your expert booking has been successful. Now, you can connect with your expert at your convenience.</p>
                </div>
                <div className="flex flex-col w-full gap-4 md:flex-row">
                  <button
                    onClick={() =>
                      this.props.history.push(`/assessment/` + "survey")
                    }
                    className="bg-[#4CAF50] hover:bg-[#43A047] text-[#fff] font-medium  w-full lg:w-[270px] justify-center duration-150 transition-all py-3 px-8 md:rounded uppercase space-x-2 flex items-center  cursor-pointer text-lg"
                  >
                    <span>View My Experts</span>
                  </button>
                </div>
              </div>
              <div className="flex justify-center ">
                <svg width="200" height="200" viewBox="0 0 280 245" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M226.853 56.6006C226.853 49.8246 215.51 38.4821 208.734 38.4821C215.51 38.4821 226.853 27.1395 226.853 20.3635C226.853 27.1395 238.195 38.4821 244.971 38.4821C238.195 38.4821 226.853 49.8246 226.853 56.6006Z" fill="#4CAF50" />
                  <path d="M245.346 183.873C245.346 177.573 234.8 167.027 228.5 167.027C234.8 167.027 245.346 156.482 245.346 150.182C245.346 156.482 255.892 167.027 262.192 167.027C255.892 167.027 245.346 177.573 245.346 183.873Z" fill="#4CAF50" />
                  <path d="M49.642 59.818C49.642 55.534 42.4715 48.3635 38.1875 48.3635C42.4715 48.3635 49.642 41.1929 49.642 36.9089C49.642 41.1929 56.8126 48.3635 61.0966 48.3635C56.8126 48.3635 49.642 55.534 49.642 59.818Z" fill="#4CAF50" />
                  <path opacity="0.5" d="M37.5455 226.545C37.5455 212.502 14.0433 189 0 189C14.0433 189 37.5455 165.498 37.5455 151.454C37.5455 165.498 61.0476 189 75.0909 189C61.0476 189.005 37.5455 212.502 37.5455 226.545Z" fill="#4CAF50" />
                  <path d="M37.5391 203.786C37.5391 198.258 28.2813 188.997 22.75 188.997C28.2787 188.997 37.5391 179.737 37.5391 174.208C37.5391 179.737 46.7995 188.997 52.3282 188.997C46.7944 189 37.5391 198.255 37.5391 203.786Z" fill="#4CAF50" />
                  <path d="M209.804 96.0746C207.125 93.2743 204.353 90.3887 203.308 87.8514C202.342 85.5272 202.285 81.675 202.228 77.9436C202.121 71.0068 202.008 63.146 196.542 57.6804C191.076 52.2148 183.216 52.1011 176.279 51.9945C172.547 51.9377 168.695 51.8808 166.371 50.9142C163.841 49.8694 160.948 47.0975 158.148 44.418C153.244 39.7058 147.671 34.3682 140.251 34.3682C132.831 34.3682 127.266 39.7058 122.355 44.418C119.555 47.0975 116.669 49.8694 114.132 50.9142C111.822 51.8808 107.955 51.9377 104.224 51.9945C97.2871 52.1011 89.4263 52.2148 83.9607 57.6804C78.4951 63.146 78.4169 71.0068 78.2748 77.9436C78.2179 81.675 78.1611 85.5272 77.1945 87.8514C76.1497 90.3816 73.3778 93.2743 70.6983 96.0746C65.9861 100.979 60.6484 106.551 60.6484 113.971C60.6484 121.391 65.9861 126.956 70.6983 131.867C73.3778 134.668 76.1497 137.553 77.1945 140.091C78.1611 142.415 78.2179 146.267 78.2748 149.998C78.3814 156.935 78.4951 164.796 83.9607 170.262C89.4263 175.727 97.2871 175.841 104.224 175.948C107.955 176.004 111.808 176.061 114.132 177.028C116.662 178.073 119.555 180.845 122.355 183.524C127.259 188.236 132.831 193.574 140.251 193.574C147.671 193.574 153.237 188.236 158.148 183.524C160.948 180.845 163.834 178.073 166.371 177.028C168.695 176.061 172.547 176.004 176.279 175.948C183.216 175.841 191.076 175.727 196.542 170.262C202.008 164.796 202.121 156.935 202.228 149.998C202.285 146.267 202.342 142.415 203.308 140.091C204.353 137.561 207.125 134.668 209.804 131.867C214.517 126.963 219.854 121.391 219.854 113.971C219.854 106.551 214.517 100.986 209.804 96.0746ZM172.704 100.936L132.902 140.738C132.374 141.266 131.747 141.686 131.057 141.972C130.367 142.258 129.627 142.405 128.879 142.405C128.132 142.405 127.392 142.258 126.702 141.972C126.012 141.686 125.385 141.266 124.857 140.738L107.799 123.68C106.732 122.613 106.133 121.166 106.133 119.657C106.133 118.148 106.732 116.701 107.799 115.634C108.866 114.567 110.313 113.968 111.822 113.968C113.331 113.968 114.778 114.567 115.845 115.634L128.879 128.676L164.658 92.8905C165.186 92.3622 165.814 91.9432 166.504 91.6573C167.194 91.3714 167.934 91.2242 168.681 91.2242C169.428 91.2242 170.168 91.3714 170.858 91.6573C171.548 91.9432 172.175 92.3622 172.704 92.8905C173.232 93.4188 173.651 94.0459 173.937 94.7362C174.223 95.4264 174.37 96.1662 174.37 96.9133C174.37 97.6604 174.223 98.4002 173.937 99.0904C173.651 99.7806 173.232 100.408 172.704 100.936Z" fill="#4CAF50"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* {getDetails("orderNumber") ? */}
        <section className="flex flex-col w-full gap-10 px-4 mx-auto mb-10 2xl:w-9/12 xl:w-10/12 xl:px-0 lg:flex-row ">
          <div className="lg:w-[65%] w-[100%] py-10 ">
            <div className="border">
              <div className="flex justify-between p-4 bg-gray-100 border-b">
                <div className="flex items-center space-x-4">
                  <div>
                    <h1 className="md:text-2xl text-xl font-medium text-[#3D405B]">
                      Booking No: {getExpertDetails(getExpertOrderBookIdData, 1, "orderNumber")}
                      {/* Order No: #{getDetails("orderNumber")} */}
                    </h1>{" "}
                    <span className="md:text-base text-sm text-[#3D405B]/70">
                      <span className="pr-2">Booking Date On:</span>
                      {moment(new Date(parseInt(getExpertDetails(getExpertOrderBookIdData, 1, "createdAt"))))
                        .utcOffset("+05:30")
                        .format("ddd, Do MMM, YYYY")}
                      {/* Wed, 6th Sep, 2023 */}
                    </span>
                  </div>
                </div>
                <div className="pt-3">
                  {/* <span className="md:text-base text-sm text-[#3D405B]/70">
                    (
                      {getDetails("orderPacks") &&
                        getDetails("orderPacks").length > 0
                        ? getDetails("orderPacks").length
                        : 0}{" "}
                      items)
                  </span> */}
                </div>
              </div>

              <div className="p-6 divide-y">
                <div className="space-y-4">
                  <div className="flex flex-row  md:gap-6 gap-4 md:items-center items-start   ">
                    <div className=" cursor-pointer flex items-center md:w-32 w-20 md:h-32 h-20 ">
                      <img
                        src={getExpertDetails(getExpertOrderBookIdData, 2, "expertId", "imageLinkV2")}
                        className="md:w-32 w-20 md:h-32 h-20 overflow-cover rounded-xl"
                      />{" "}
                    </div>

                    <div className="w-full  space-y-2 flex-1 ">
                      <div className="text-[#3D405B] flex  2xl:flex-row flex-col md:gap-4 gap-2 justify-between w-full ">
                        <h1 className="  md:text-2xl text-lg">{getExpertDetails(getExpertOrderBookIdData, 2, "expertId", "name")}</h1>
                        <h1 className="  md:text-2xl text-lg  font-semibold ">
                          <span className="font-[roboto]"> ₹</span>{getExpertDetails(getExpertOrderBookIdData, 1, "total")}
                        </h1>
                      </div>
                      <div className="  space-y-2 items-center">
                        <p className="text-[#3D405B]/70 capitalize">{getExpertDetails(getExpertOrderBookIdData, 2, "expertId", "type")}</p>
                        <div className="flex items-center">
                          <div className="flex items-center">
                            <p className="text-[#3D405B] tracking-wide">Rating: </p>
                            {[1, 2, 3, 4, 5].map((star, index) =>
                              (index < parseFloat(getExpertDetails(getExpertOrderBookIdData, 2, "expert", "rating"))) ?
                                <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
                                  </path>
                                </svg>
                                :
                                <svg className="w-5 h-5 text-gray-300 dark:text-gray-500" fill="currentColor" viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
                                  </path>
                                </svg>
                            )}
                          </div>
                          <p className="text-sm font-medium text-gray-500 ms-1 dark:text-gray-400">{getExpertDetails(getExpertOrderBookIdData, 1, "rating")}</p>
                          <p className="text-sm font-medium text-gray-500 ms-1 dark:text-gray-400">out of</p>
                          <p className="text-sm font-medium text-gray-500 ms-1 dark:text-gray-400">5</p>
                        </div>
                        {/* <p className="text-[#3D405B]/70 ">Desc:{" "} After working in different firms including Indian conglomerates...</p> */}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className="lg:w-[35%] w-full md:py-10 text-[#3D405B] ">
            <div className="border">
              <div className="flex items-center justify-start p-4 px-6 space-x-4 bg-gray-100">
                <h1 className="2xl:text-2xl xl:text-xl  text-xl  text-[#3D405B]">
                  Order Summary
                </h1>{" "}
                <span className="xl:text-lg text-base text-[#3D405B]/70 ">
                  {/* (
                    {getDetails("orderPacks") &&
                      getDetails("orderPacks").length > 0
                      ? getDetails("orderPacks").length
                      : 0}{" "}
                    items) */}

                </span>
              </div>

              <div className="p-3 px-6">
                <div className="space-y-8 text-lg md:text-xl">
                  <div className="flex items-center justify-between capitalize">
                    <p className="">Subtotal</p>
                    <p className="font-medium "> <span className="font-[roboto]">₹</span>{getExpertDetails(getExpertOrderBookIdData, 1, "total")}</p>
                    {/* <p className="font-medium "> <span className="font-[roboto]">₹</span>{getDetails("sum")}</p> */}
                  </div>
                  <div className="flex items-center justify-between py-6 capitalize border-t-2 border-dashed ">
                    <p className="font-bold ">Total Payable</p>
                    <p className="font-bold "> <span className="font-[roboto]">₹</span>{getExpertDetails(getExpertOrderBookIdData, 1, "total")}</p>
                    {/* <p className="font-bold "> <span className="font-[roboto]">₹</span>{getDetails("total")}</p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* : null} */}


        <Footer
        // props2={this.props}
        // prodList={getAssessmentPackagesShortListData}
        // gotoMyAccount={this.gotoMyAccount}
        />
      </>
    );
  }
}
function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { users, dashboard, assessment } = state;
  return {
    loggingIn,
    users,
    dashboard,
    assessment
  };
}
export default connect(mapStateToProps)(BackSummary);
